import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f74860e")

_pushScopeId("data-v-6f74860e")
const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { class: "t-head" }
const _hoisted_5 = { class: "tr" }
const _hoisted_6 = { class: "t-body" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_my_card_body = _resolveComponent("my-card-body")
  const _component_my_card = _resolveComponent("my-card")

  return (_openBlock(), _createBlock(_component_my_card, { class: "mt-4 flex-1 d-flex flex-column" }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, _toDisplayString($props.title), 1)
    ]),
    default: _withId(() => [
      _createVNode(_component_my_card_body, { style: {"height":"100%","display":"flex"} }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.thead, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "td",
                      key: item
                    }, _toDisplayString(item), 1))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("div", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.list, (r, i) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "tr",
                      key: i
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(r, (d) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "td",
                          key: d
                        }, [
                          ($setup.Type.IMAGE === d.type)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                src: d.value,
                                alt: ""
                              }, null, 8, ["src"]))
                            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(d.value), 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */))
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})